import { useContext, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import UserContext from "src/provider/state-manager/userProvider"
import ApiContext from "src/provider/API/call-service"
import { AppLink, AppSpan, AppText, AuthOtpLabelD2, Button, CustomContainer, FlexRow, Form, GridContainer, OnboardingOtpLabel, ScreenTitle } from "src/style"
import { AppCenterPopupD2, CenterPopupHeaderD2 } from "src/component"
import helpers from "src/utils/helpers"
import { handleTypeNumberControl } from "src/utils/utility"
import ResendIcon from 'src/assets/svg/resend-otp-icon'

export const AuthOtpD2: React.FC<any> = ({next, back, close}) => {
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const {user: {userInfo}} = useContext(UserContext)
    const [otp, setOtp] = useState('')

    let phoneNo = userInfo?.profileInfo.phoneNumber

    const handlePin = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 7) {
            setOtp(e.target.value)
        }
    }

    function handleResendOtp() {
        API.resendTransactionOtp()
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (otp.length != 6) return notifier.show('Kindly provide a valid Otp', 'Validation Response')
        if (next) {
            next(helpers.hashString(otp))
        }
    }


    return (
        <AppCenterPopupD2 height='43.5' zIndex='6' overflow='hidden' close={close}>
            <CenterPopupHeaderD2 title='One Time Password' close={close} back={back} />
            <CustomContainer 
                height="43.5"
                style={{maxHeight: '100%'}}
                className="popup-content-container"
            >
                <CustomContainer topMargin="0.5">
                    <AppText align="center">
                        Please enter the One Time Password (OTP) sent to your Phone Number 
                        <AppSpan color='#0EA59D' fontWeight='600'> {`${phoneNo.substring(0, 4)}####${phoneNo.substring(8, phoneNo.length)}`} </AppSpan>
                    </AppText>
                    <Form onSubmit={handleProceed} topMargin='2'>
                        <GridContainer>
                            <FlexRow 
                                width="auto" sizeUnit="" gap='1.4'
                                className="auth-otp-flex"
                            >
                                <input 
                                    className='display-hidden' id='code' 
                                    name="otp" value={otp}
                                    onChange={handlePin} 
                                    onKeyDown={handleTypeNumberControl}
                                    onKeyUp={handleTypeNumberControl}
                                    autoFocus={true} autoComplete="off"
                                />
                                <AuthOtpLabelD2 className={`${otp.length === 0 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[0] ? '*' : ''}</AuthOtpLabelD2>
                                <AuthOtpLabelD2 className={`${otp.length === 1 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[1] ? '*' : ''}</AuthOtpLabelD2>
                                <AuthOtpLabelD2 className={`${otp.length === 2 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[2] ? '*' : ''}</AuthOtpLabelD2>
                                <AuthOtpLabelD2 className={`${otp.length === 3 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[3] ? '*' : ''}</AuthOtpLabelD2>
                                <AuthOtpLabelD2 className={`${otp.length === 4 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[4] ? '*' : ''}</AuthOtpLabelD2>
                                <AuthOtpLabelD2 className={`${otp.length >= 5 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[5] ? '*' : ''}</AuthOtpLabelD2>
                            </FlexRow>
                        </GridContainer>
                        <GridContainer
                            bgColor='#E7F6F5' minHeight='6.2' radius='0.8'
                            shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                            padding='2' topPadding='1' bottomPadding='1'
                            topMargin='2.5'
                        >
                            <FlexRow gap='1.5' className='test-safari'>
                                <ResendIcon className='icon-component' />
                                <AppText textSize='1.2' color='#0A756F'>
                                    Did not receive OTP.
                                    <AppLink 
                                        textSize='1.2' color='#0A756F' fontWeight='700' 
                                        hoverColor='#000000' leftMargin="0.5"
                                        onClick={handleResendOtp}
                                    > 
                                        Tap here to resend 
                                    </AppLink> 
                                </AppText>
                            </FlexRow>
                        </GridContainer>
                        <FlexRow justifyContent='flex-end' gap='1.5' topMargin='2' >
                            <Button 
                                width='100' sizeUnit="%" height='4.4'
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopupD2>
    )
}